import React from 'react';
import { func } from 'prop-types';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import BobConfirmButton from '../../../components/BobConfirmButton';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import * as ArchitectActions from '../../../actions/architectActions';
import * as ApplicationMessageActions from '../../../actions/applicationMessageActions';
import * as UiActions from '../../../actions/uiActions';

import classes from '../CreateEntityModal.module.css';

const DeleteSystemModal = ({
    clearErrors,
    deleteSystem,
    fetchDashboardSystems,
    isLoading,
    onClose,
    system,
    toggleLoading
}) => {
    
    const handleDelete = async () => {
        const clientId = system.clientId;

        let isDeleted;

        if (!isLoading) {
            toggleLoading(true);
            isDeleted = await deleteSystem(system.systemId, system.siteId, clientId);
        }

        if (isDeleted) handleClose(isDeleted);
    };

    const handleClose = (isDeleted) => {
        const body = {};
        clearErrors();
        toggleLoading(false);
        if (isDeleted) fetchDashboardSystems(body);
        onClose();
    };

    return (
        <React.Fragment>
            <ErrorOutlineIcon className={classes.warningIcon} />
            <div className={classes.text}>
                <p className={classes.desc}> Are you sure you want to delete the entity below?</p>
                <p className={classes.name}>System</p>
                <p className={classes.entityName}>{system.systemName}</p>
            </div>
            <Button
                className={classes.Button}
                onClick={onClose}
                variant="contained"
            >
                Cancel
            </Button>
            <BobConfirmButton
                className={classes.ButtonWithMargin}
                isLoading={isLoading}
                label={'Yes'}
                onClick={handleDelete}
            />
        </React.Fragment>
    );
};


DeleteSystemModal.propTypes = {
    onClose: func.isRequired
};

const mapStateToProps = state => {
    return {
        isLoading: state.ui.isLoading
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSystemModal);
